import type { CashFlowFeatures } from './type';

export const cashFlow: CashFlowFeatures = {
    enabled: true,
    _description: 'Cash flow API, which provides data for the overview product card charts',
    bulkEndpoint: {
        enabled: false,
        _description: 'Use experimental bulk cash flow API for better performance',
    },
};
